import _ from "lodash";
import logger from "../utils/LoggerFrontend";
import Reflux from "reflux";

import Actions from "../Actions";

// eslint-disable-next-line import/no-unresolved
import { CustomerSucessController } from "@talentbait/shared-components";
import { channels } from "../data/app__channels";
import database from "../utils/FirebaseController";
import { getBudgetByDuration, cleanTitle, calculateExtraLocationBudget } from "../utils/Helpers";
import { getCompanyImageFolderName } from "../utils/GetCompanyFolderName";
import { formatNewPosts } from "./utils";
import { extractImageSuggestions, extractPageImage } from "../utils/CampaignCreationStore.utils";
import { ADD_ON_PRICE } from "../PagesUser/SelfServiceCampaignCreation/campaign-creation/utils/constants";
import i18next from "i18next";
import { DEFAULT_JOB_CATEGORY } from "../PagesUser/Campaign/constants";
import { getLanguageByLocale } from "../PagesUser/ad-assistant/utils";

const DEFAULT_BUGET_EUR = 400;
const googlDisplay = _.find(channels, { channel_short_name: "google-display" });
const facebook = _.find(channels, { channel_short_name: "facebook" });
const instagram = _.find(channels, { channel_short_name: "instagram" });
const youtube = _.find(channels, { channel_short_name: "youtube" });

const DEFAULT_PAGE = {
  value: 24,
  label: "Sonstiges",
  pageName: "JobHappier",
  pageId: "716047581885055",
  pageLogo: "jobhappier.png"
};

const CLICK_PROMISE_FACTOR = 0.5;

const _defaultTalentBaitPackages = [
  {
    budget: 400,
    minClicks: 400 * CLICK_PROMISE_FACTOR,
    id: "std--small",
    name: "Small",
    nameShort: "S",
    description: "Laufzeit 30 Tage. 240 qualifizierte Klicks direkt aus Facebook und Instagram.",
    selectedChannels: [facebook, instagram],
    duration: 30
  },
  {
    budget: 800,
    minClicks: 800 * CLICK_PROMISE_FACTOR,
    id: "std--medium",
    name: "Medium",
    nameShort: "M",
    description:
      "Laufzeit 30 Tage. 480 qualifizierte Klicks direkt aus Facebook, Instagram oder Google.",
    selectedChannels: [facebook, instagram, googlDisplay],
    duration: 30
  },
  {
    budget: 1200,
    minClicks: 1200 * CLICK_PROMISE_FACTOR,
    id: "std--large",
    name: "Large",
    nameShort: "L",
    description:
      "Laufzeit 30 Tage. 720 qualifizierte Klicks direkt aus Facebook, Instagram, YouTube und Google.",
    selectedChannels: [facebook, instagram, googlDisplay, youtube],
    duration: 30
  }
];

const defaultState = {
  emitCampaignCreation: false,
  startCampaignCreation: false,
  selfServiceBookingStyle: "WITHOUT_AUTO_LIVE",

  currentStep: "STEP_BASE_DATA",
  bookingStyle: "new", // "new" vs. "old"
  disableChangingBookingStyle: false,
  organization: {},
  campaignGoal: "traffic",
  companyLogo: "",

  ////// BASE DATA
  jobTitle: "",
  jobPostingUrl: "",
  location: [],
  startDate: null,
  campaignDuration: 30,
  locale: "de_DE",
  companyName: "",
  companyId: "",
  jobId: null, // For campaigns that are created based on jobs

  ////// New Preview
  posts: [],
  unsavedPosts: [],

  //// Review states
  canUseWebsitePictures: true,
  historicalPictures: [],
  pictures: [],
  willUploadPicturesLater: false,
  activeDate: "now",
  invoiceAddresses: [],
  isLoadingInvoiceAddresses: true,
  currentlySelectedAddress: null,
  creatingDebitoorCompany: false,
  poNumber: "",
  paymentType: "invoice",

  //// Budget Check & Packages
  selectedChannels: [],
  upsellChannels: [],
  predictions: undefined,
  lifeTimeBudget: DEFAULT_BUGET_EUR,
  jobCategoryId: undefined,
  packageId: undefined,
  minClicksPackage: undefined,
  packages: Object.assign({}, _defaultTalentBaitPackages),
  extraBudgetLocations: [],
  draftLimit: 5,

  //// Qualification question
  atsData: {},

  // Booking related states
  isBooking: false,
  isSavingPreviews: false,
  campaignBookingError: "",
  showDraftButton: true,
  isCreatingDraft: false,
  isFirstCampaign: false,

  // Budget
  recommendedChannels: [],

  jobCategory: 0,
  benefits: [],
  tasks: [],
  teaserText: "",
  page: DEFAULT_PAGE,
  atsId: "",

  /// Add ons
  optimizeAnalysis: ADD_ON_PRICE,
  feedbackAnalysis: ADD_ON_PRICE,
  spotifyHumanVoice: ADD_ON_PRICE
};

export default class CampaignCreationStore extends Reflux.Store {
  constructor() {
    super();
    logger.debug("CampaignCreationStore:constructor", "called");
    this.state = Object.assign({}, defaultState);
    this.listenables = Actions;
  }

  onEmitCampaignCreation(createCampaign) {
    this.setState({
      emitCampaignCreation: createCampaign
    });
  }

  onStartCampaignCreation(startCampaignCreation) {
    this.setState({
      startCampaignCreation: startCampaignCreation
    });
  }

  onLoadDraftCampaign(campaignId) {
    this.setState({
      loadingDraft: true,
      draftCampaignId: campaignId,
      atsId: campaignId
    });
  }

  onClearDraftCampaign() {
    this.setState({
      loadingDraft: false,
      draftCampaignId: null,
      atsId: null
    });
  }

  onLoadDraftCampaignCompleted(campaign) {
    logger.log("CampaignCreateStore:onLoadDraftCampaignCompleted", "called", {
      campaign
    });

    const {
      posts,
      companyName,
      minClicksPackage,
      bookingStyle,
      jobCategoryId,
      packageId,
      packages,
      jobPostingUrl,
      locations,
      jobTitle,
      lifeTimeBudget,
      selectedChannels,
      predictions,
      campaignDuration,
      poNumber = "",
      lastEditStage,
      orgaName,
      startDate = null,
      organizationId: orgaId,
      optimizeAnalysis = null,
      feedbackAnalysis = null,
      spotifyHumanVoice = null,
      isLoadingInvoiceAddresses,
      locale,
      companyId,
      jobId
    } = campaign;

    const extraBudgetLocations = calculateExtraLocationBudget(locations) || [];

    this.setState({
      loadingDraft: false,
      // Draft data
      posts,
      bookingStyle,
      location: locations,
      companyName,
      companyId,
      jobId,
      jobPostingUrl,
      jobTitle,
      jobCategoryId,
      packageId,
      packages,
      minClicksPackage,
      selectedChannels,
      predictions,
      upsellChannels: _.differenceBy(channels, selectedChannels, "channel_short_name"),
      lifeTimeBudget: lifeTimeBudget ? parseInt(lifeTimeBudget, 10) : null,
      poNumber,
      campaignDuration: parseInt(campaignDuration || 30, 10),
      extraBudgetLocations,
      // TODO: if we use the last step we will skip the base step which calls the getAdPreviewData action,
      // this action is necessary for the preview step to work properly - we need to refactor the code if we want to keep the last step
      currentStep: lastEditStage || "STEP_BASE_DATA",
      startDate,
      optimizeAnalysis,
      feedbackAnalysis,
      spotifyHumanVoice,
      isLoadingInvoiceAddresses,
      locale
    });

    const cloudinaryData = { jobTitle: cleanTitle(jobTitle) };
    const { folderName, metadata } = getCompanyImageFolderName({
      orgaId,
      companyId,
      orgaName,
      companyName,
      metadata: cloudinaryData
    });

    if (lastEditStage && lastEditStage != "STEP_BASE_DATA") {
      // Constructs object

      const language = getLanguageByLocale(locale || "de_DE");
      const data = {
        jobPostingUrl,
        jobTitle,
        orgaName,
        orgaId,
        companyName,
        location: locations,
        folderName,
        metadata,
        language
      };
      // Get preview data
      Actions.getAdPreviewData(data);
      // Trigger teaser recom
      Actions.getTeaserTextRecommendation({
        url: jobPostingUrl,
        jobTitle,
        companyName,
        location: locations?.[0],
        orgaId
      });
    }
  }

  onLoadDraftCampaignFailed(err) {
    logger.log("error:CampaignCreateStore:onLoadDraftCampaignFailed", "called", err);
    this.setState({
      loadingDraft: false,
      draftCampaignId: null
    });
  }

  onSwitchBookingStyle(flavor) {
    const { campaignDuration } = this.state;
    const data = {
      bookingStyle: flavor
    };
    // if the user switches to the old booking style, we need to reset some state.
    if (flavor === "old") {
      data["lifeTimeBudget"] = getBudgetByDuration(DEFAULT_BUGET_EUR, campaignDuration);
      data["selectedChannels"] = [];
      data["channels"] = [];
      data["predictions"] = undefined;
      data["upsellChannels"] = [];
    } else {
      data["minClicksPackage"] = undefined;
    }

    logger.log("CampaignCreateStore:switchBookingStyle", "called", flavor, data);

    this.setState(data);

    CustomerSucessController.send("CampaignCreate:switchBookingStyle", {
      newBookingStyle: flavor
    });
  }

  onCreateDebitoorCompany(props) {
    logger.log("CampaignCreateStore:onCreateDebitoorCompany", "called...", props);
    this.setState({
      creatingDebitoorCompany: true
    });
  }
  onCreateDebitoorCompanyCompleted({ payload: address }) {
    const { organization } = this.state;
    logger.log("CampaignCreateStore:onCreateDebitoorCompanyCompleted", "called...", {
      address,
      organization
    });
    if (_.isEmpty(organization)) {
      logger.log("CampaignCreateStore:onCreateDebitoorCompanyCompleted", "no organization", {
        organization
      });
      return this.setState({
        creatingDebitoorCompany: false
      });
    }
    Actions.addNotification(i18next.t("billing address created"));
    const newInvoicesReceivers = _.uniq(
      (organization.invoicesReceivers || []).concat([address.id])
    );
    Actions.notifiyEvent({
      eventName: "Rechnungansadressen",
      text: `🧾 Neue Rechnungsanschrift wird für *${address.name}* / ${organization.name} hinzugefügt`
    });
    this.setState({
      organization: { ...this.state.organization, invoicesReceivers: newInvoicesReceivers },
      invoiceAddresses: _.uniqBy(this.state.invoiceAddresses.concat(address), "id"),
      creatingDebitoorCompany: false,
      currentlySelectedAddress: address
    });
  }
  onCreateDebitoorCompanyFailed(error) {
    logger.log("error:CampaignCreateStore:onCreateDebitoorCompanyFailed", "called...", error);
    Actions.addNotification(i18next.t("The creation of the billing address failed"), "error");
    this.setState({
      creatingDebitoorCompany: false
    });
  }

  onGetCustomerAddresses(invoiceAddresses, showLoader = true) {
    logger.log("CampaignCreateStore:onGetCustomerAddresses", "listen...", {
      invoiceAddresses,
      showLoader
    });

    this.setState({
      isLoadingInvoiceAddresses: showLoader
    });
  }

  onGetCustomerAddressesFailed(addresses = []) {
    logger.log("CampaignCreateStore:onGetCustomerAddressesFailed", "called...", {
      ...addresses
    });

    this.setState({
      invoiceAddresses: [],
      isLoadingInvoiceAddresses: false
    });
  }

  onGetCustomerAddressesCompleted(addresses = []) {
    logger.log("CampaignCreateStore:onGetCustomerAddressesCompleted", "called...", {
      ...addresses
    });

    const invoiceAddresses = addresses?.filter((address) => !!address?.id);
    this.setState({
      invoiceAddresses,
      isLoadingInvoiceAddresses: false
    });
  }

  // getCustomerAddresses
  async onLoadOrganizationOfCampaignCompleted(organization) {
    logger.log("CampaignCreateStore:onLoadOrganizationOfCampaignCompleted", "called...", {
      orgaId: organization.id
    });

    const {
      campaignGoal,
      bookingStyle,
      disableChangingBookingStyle,
      companyName,
      draftCampaignId
    } = this.state;
    let newCompanyName = companyName;
    // Get invoice addresses associated with this organization
    if (organization && organization.invoicesReceivers && organization.invoicesReceivers.length) {
      Actions.getCustomerAddresses(organization.invoicesReceivers, false);
    }

    // Change the default booking style based on the orga setting
    if (
      organization &&
      organization.bookingStyle &&
      bookingStyle != organization.bookingStyle &&
      !draftCampaignId
    ) {
      logger.debug(
        "CampaignCreateStore:onLoadOrganizationOfCampaignCompleted",
        "Switched booking system...bookingStyle:",
        {
          bookingStyle: organization.bookingStyle
        }
      );
      this.setState({
        bookingStyle: organization.bookingStyle
      });
    }

    // Check if changing the booking style should be disabled for the organization
    if (
      organization &&
      organization.disableChangingBookingStyle &&
      disableChangingBookingStyle != organization.disableChangingBookingStyle
    ) {
      logger.debug(
        "CampaignCreateStore:onLoadOrganizationOfCampaignCompleted",
        "Switched booking system...disableChangingBookingStyle:",
        { disableChangingBookingStyle: organization.disableChangingBookingStyle }
      );
      this.setState({
        disableChangingBookingStyle: organization.disableChangingBookingStyle
      });
    }

    if (organization) {
      newCompanyName = organization.isAgency ? companyName : organization.name || companyName;
    }
    let companyLogo = "";
    if (organization && organization.clientType == "client") {
      companyLogo = organization.companyLogo || "";
    }

    let campaignGoalOnOrgaLevel = organization && organization.campaignGoal;

    const nrOfDraft = await database.getDraftNumberCampaignsOfOrg(organization.id);
    let draftLimit = 5;

    try {
      if (organization?.allowDraftCampaigns && organization?.draftLimit) {
        draftLimit = parseInt(organization?.draftLimit, 10) || 5;
      }
    } catch (error) {
      logger.log(
        "error:CampaignCreateStore:onLoadOrganizationOfCampaignCompleted",
        "failed parsing draft count",
        { error }
      );
      draftLimit = 5;
    }

    this.setState({
      organization,
      nrOfDraft,
      draftLimit,
      // DO NOT SET COMPANY NAME HERE (crashes booking draft campaigns)
      ...(draftCampaignId ? {} : { companyName: newCompanyName }),
      campaignGoal: campaignGoalOnOrgaLevel || campaignGoal || "traffic",
      companyLogo,
      selfServiceBookingStyle: organization.selfServiceBookingStyle || "",
      paymentType: organization.paymentType || "invoice"
    });
  }

  onGetCampaignManagerCompleted(campaignManager) {
    logger.log(
      "CampaignCreateStore:onGetCampaignManagerCompleted",
      "handlerGetCampaignManager...",
      { campaignManager }
    );

    let { meta } = campaignManager;

    this.setState({
      campaignManager: meta && meta.campaignManager
    });
  }
  onGenerateJobPageCompleted(result) {
    logger.log(
      "CampaignCreateStore:onGenerateJobPageCompleted",
      "finished generating job page data",
      { result }
    );
    this.setState({
      atsId: result?.payload?.atsId
    });
  }

  onGetAdPreviewDataFailed(err) {
    logger.log(
      "error:CampaignCreateStore:onGetAdPreviewDataFailed",
      "Error loading ad previews",
      err
    );
    this.onGetAdPreviewDataCompleted(undefined, undefined, true);
  }

  onGetAdPreviewDataCompleted(data, params, hasError) {
    //
    // This handler is being called after the backend checked the job ad
    // and tried to extract benefits and suitable photos in the HTML.
    //
    //

    logger.debug("CampaignCreateStore:onGetAdPreviewDataCompleted", "got data...", {
      data,
      params,
      hasError
    });

    // In case there is no data or an error returned we straight go to the
    // next step.
    if (hasError || !data || (data && !data.payload)) {
      logger.log(
        "error:CampaignCreateStore:onGetAdPreviewDataCompleted",
        "No preview information found...",
        {
          hasError,
          data
        }
      );

      return this.setState({
        benefits: [],
        pictures: [],
        tasks: [],
        requirements: [],
        teaserText: "",
        page: (data && data.payload && data.payload.pages[0]) || DEFAULT_PAGE,
        isLoading: false
      });
    }

    //
    // The backend found information, lets
    //
    let previewInformation = data.payload;
    logger.debug("CampaignCreateStore:onGetAdPreviewDataCompleted", "called...", {
      previewInformation,
      pages: previewInformation.pages
    });

    const { organization, jobPostingUrl } = this.state;
    const isPLG = organization.signupType === "PLG";
    logger.log(`CampaignCreate:setPreviewData:isPLG:${isPLG}`, "job post scrapping report", {
      organization,
      jobPostingUrl,
      scrappedAssets: previewInformation.pageImage,
      suggestions: previewInformation.suggestions
    });

    let allPictures = this.state.historicalPictures || [];
    let selectedPicture = undefined;

    // If we found images add them to the list
    const { pageImage, suggestions } = previewInformation;
    allPictures = extractPageImage(allPictures, pageImage);

    if (!selectedPicture) {
      selectedPicture = allPictures[0];
    }

    allPictures = extractImageSuggestions(allPictures, suggestions);
    if (!selectedPicture) {
      selectedPicture = allPictures[0];
    }

    allPictures = _.uniqBy(allPictures, "image_url");

    // If there was an issue with loading the page image data

    const previewData = {
      benefits: previewInformation.benefits || [],
      tasks: previewInformation.tasks || [],
      requirements: previewInformation.requirements || [],
      teaserText: previewInformation.teaserText || "",
      page: previewInformation.pages[0],
      historicalPictures: allPictures,
      isLoading: false
    };
    if (selectedPicture) {
      previewData.pictures = [selectedPicture];
    }

    logger.log("CampaignCreateStore:onGetAdPreviewDataCompleted", "prepared data", { previewData });

    CustomerSucessController.send("CampaignCreate:FetchedPreviewData", { previewData });

    return this.setState(previewData);
  }

  onCreateCampaignAndSave(orgaId, campaignData, adPreviewData = {}, withAdpreview) {
    logger.log("CampaignCreateStore:onCreateCampaignAndSave", "campaign creation triggered", {
      orgaId,
      campaignData,
      adPreviewData,
      withAdpreview
    });

    const { draftCampaignId } = this.state;

    if (draftCampaignId) {
      logger.log("CampaignCreateStore:onCreateCampaignAndSave", "deleting draft campaign", {
        draftCampaignId
      });
      // Update the orga Id on the draft campaign so that we don't loose the draft data
      // in case the campaign creation fails
      database
        .updateCampaignWithId(draftCampaignId, {
          organizationId: `old_draft__${orgaId}__${draftCampaignId}`
        })
        .catch((error) => {
          logger.log(
            "error:CampaignCreateStore:onCreateCampaignAndSave",
            "unable to update draft campaign",
            { draftCampaignId, error }
          );
        });
    }

    this.setState({
      isBooking: true,
      isSavingPreviews: true,
      createdDate: campaignData.createdDate,
      isBookedViaSelfservice: campaignData.isBookedViaSelfservice,
      orgaId
    });
  }

  onCreateCampaignAndSaveCompleted(createdCampaignData) {
    logger.log(
      "CampaignCreateStore:onCreateCampaignAndSaveCompleted",
      "campaign successfully created",
      { createdCampaignData }
    );

    const { campaignGoal } = this.state;

    logger.log("CampaignCreate:handleCampaignCreation", "Campaign was created ✅ ...", {
      createdCampaignData,
      campaignGoal
    });

    const { payload } = createdCampaignData ?? {};
    const { campaignId, adsets } = payload ?? {};

    let adsetId;
    if (adsets?.length > 0) {
      adsetId = adsets[0].adsetId;
    }

    this.setState({
      campaignId: campaignId,
      adsetId,
      isBooking: false,
      emitCampaignCreation: false
    });
  }

  onCreateCampaignAndSaveFailed(error) {
    logger.log("error:CampaignCreateStore:onCreateCampaignAndSaveFailed", "called", { error });
    this.setState({
      campaignBookingError: "Kampagne wurde nicht erstellt",
      isBooking: false,
      isSavingPreviews: false,
      emitCampaignCreation: false
    });
    Actions.addNotification(
      i18next.t("Campaign was not created. Please contact support support@talentbait.com"),
      "error",
      true
    );
  }

  onSaveAdCreatives(adcreatives) {
    this.setState({ unsavedPosts: adcreatives });
  }

  onSaveAdCreativesCompleted() {
    logger.log("CampaignCreateStore:onSaveAdCreativesCompleted", "called", {});
    const { isBookedViaSelfservice, selfServiceBookingStyle } = this.state;
    let currentStep = "STEP_FINISHED";
    // If the selfservice booking style is set to automatically go live, then show countdown timer
    if (isBookedViaSelfservice && selfServiceBookingStyle == "WITH_AUTO_LIVE") {
      currentStep = "STEP_FINISHED_NEW";
    }
    this.setState({
      isSavingPreviews: false,
      currentStep
    });
  }
  onSaveAdCreativesFailed(error, data) {
    logger.log("error:CampaignCreateStore:onSaveAdCreativesFailed", "called", {
      error,
      data,
      unsavedPosts: JSON.stringify(this.state.unsavedPosts)
    });
    const { isBookedViaSelfservice, selfServiceBookingStyle } = this.state;
    let currentStep = "STEP_FINISHED";
    // If the selfservice booking style is set to automatically go live, then show countdown timer
    if (isBookedViaSelfservice && selfServiceBookingStyle == "WITH_AUTO_LIVE") {
      currentStep = "STEP_FINISHED_NEW";
    }
    this.setState({
      isSavingPreviews: false,
      currentStep
    });
  }

  onCampaignCreateUpdateBaseData(formData, needBudgetCheck = true) {
    logger.log("CampaignCreateStore:UpdateBaseData", "updating base data form fields", formData);
    this.setState({ ...formData, budgetCheck: needBudgetCheck ? true : false });
  }

  debounceCustomerData = _.debounce((data) => {
    CustomerSucessController.send("CampaignCreate:budgetSlider", {
      packageId: data.packageId,
      selectedChannels: data.selectedChannels,
      campaignBudget: data.lifetime,
      predictions: data.predictions
    });
  }, 1000);

  onLoadPackagesByOrgaCompleted(allPackagesOfOrga = []) {
    logger.debug("CampaignCreateStore:onLoadPackagesByOrgaCompleted", "finished...", {
      allPackagesOfOrga
    });

    let { packageId, lifeTimeBudget, minClicksPackage } = this.state;

    let filteredPackageList = allPackagesOfOrga;
    if (allPackagesOfOrga.length == 0) {
      filteredPackageList = _defaultTalentBaitPackages;
    }

    logger.debug("CampaignCreateStore:onLoadPackagesByOrgaCompleted", "called...", {
      filteredPackageList,
      packageId,
      lifeTimeBudget,
      minClicksPackage
    });

    if (!packageId || packageId == "newBooking") {
      const firstPackage = filteredPackageList[0];
      this.setState({
        packages: filteredPackageList,
        packageId: firstPackage.id,
        lifeTimeBudget: firstPackage.budget,
        minClicksPackage: firstPackage.minClicks,
        selectedChannels: firstPackage.selectedChannels,
        campaignDuration: parseInt(firstPackage?.duration || 30, 10) || 30
      });
    } else {
      this.setState({
        packages: filteredPackageList
      });
    }
  }
  ///// Handlers for changes in budget calculator
  onCampaignCreateUpdateBudgetData(data) {
    logger.debug("CampaignCreateStore:onCampaignCreateUpdateBudgetData:jobCat", "called...", data);

    this.setState(data);
  }

  onCampaignUpdateIsFirstCampaign(data) {
    logger.debug("CampaignCreateStore:onCampaignUpdateIsFirstCampaign", "called...", data);

    this.setState(data);
  }

  ///// Handlers for changes in package selector
  onCampaignCreateUpdatePackageData(data) {
    logger.log("CampaignCreateStore:onCampaignCreateUpdatePackageData", "called...", data);

    this.setState(data);
  }

  ///// Handlers for changes in ATS sections
  onCampaignCreateUpdateATSData(data) {
    logger.log("CampaignCreateStore:onCampaignCreateUpdateATSData", "called...", data);

    this.setState(data);
  }

  ///// Handlers for changes in Preview data
  onCampaignCreateUpdatePreviewData(data) {
    logger.log("CampaignCreateStore:onCampaignCreateUpdatePreviewData", "called...", data);

    this.setState(data);
  }

  ///// Handlers for changes in Review step
  onCampaignCreateUpdateReviewData(data) {
    logger.log("CampaignCreateStore:onCampaignCreateUpdateReviewData", "called...", data);
    this.setState(data);
  }

  onCampaignCreateResetData() {
    const newState = Object.assign({}, { ...defaultState, organization: this.state.organization });
    logger.debug("CampaignCreateStore:onCampaignCreateResetData", "called...", { newState });

    this.setState(newState);
  }

  onCampaignCreateUpdateDraftStatus(data) {
    logger.debug("CampaignCreateStore:onCampaignCreateUpdateDraftStatus", "called...", data);
    this.setState(data);
  }

  onCreateCampaignDraftFailed(res) {
    logger.log("error:CampaignCreateStore:onCreateCampaignDraftFailed", "called...", {
      ...res
    });
  }

  onCreateCampaignDraftCompleted({ draftCampaignId, newPosts }) {
    logger.log("CampaignCreateStore:onCreateCampaignDraftCompleted", "called...", {
      draftCampaignId,
      newPosts
    });

    const newPostsFormatted = formatNewPosts(newPosts);

    this.setState({
      draftCampaignId: draftCampaignId || null,
      posts: newPostsFormatted.posts
    });
  }

  onGetJobCategoryCompleted({ payload }) {
    if (payload?.id) {
      this.setState({ jobCategoryId: payload.id });
      Actions.getJobCategoryWithId(payload.id);
    }
  }

  onGetJobCategoryFailed(error) {
    logger.log("error:CampaignCreateStore:onGetJobCategoryFailed", "Get job category failed", {
      error,
      errorMessage: error?.message,
      errorData: error?.data
    });
    this.setState({ jobCategoryId: DEFAULT_JOB_CATEGORY });
    Actions.getJobCategoryWithId(DEFAULT_JOB_CATEGORY);
  }

  onUpdateFirstUserCampaign(data) {
    logger.debug("CampaignCreateStore:onUpdateFirstUserCampaign", "called...", data);
    this.setState(data);
  }

  onGetOrCreateCompanyCompleted(data) {
    logger.log(
      "CampaignCreateStore:onGetOrCreateCompanyCompleted",
      "onGetOrCreateCompanyCompleted.",
      {
        data
      }
    );

    const { payload } = data;
    this.setState({
      companyId: payload.id
    });
  }

  onGetOrCreateCompanyFailed(data) {
    const { payload } = data;

    logger.log(
      "error:CampaignCreateStore:onGetOrCreateCompanyFailed",
      "error getting or creating company",
      { payload }
    );
  }
}
